import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "card-header text-base flex justify-between items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-base" }, "Catalog", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("+ Add")
const _hoisted_4 = { class: "mt-3 flex justify-between" }
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "Action", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Update cost ")
const _hoisted_8 = { style: {"float":"left"} }
const _hoisted_9 = {
  key: 0,
  style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":"13px"}
}
const _hoisted_10 = { class: "mt-3 flex" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Add ")
const _hoisted_12 = { class: "dialog-footer" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("  Save ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("  Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_slot_error = _resolveComponent("slot-error")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_el_button, { onClick: _ctx.showModalCatalog }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                class: "filter-search",
                modelValue: _ctx.state.filter.search,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.filter.search) = $event)),
                placeholder: "Search"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.state.multipleSelection.length !== 0 && _ctx.state.type === 'edit'
              )
                    ? (_openBlock(), _createBlock(_component_el_dropdown, { key: 0 }, {
                        dropdown: _withCtx(() => [
                          _createVNode(_component_el_dropdown_menu, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_dropdown_item, { onClick: _ctx.onShowAddSet }, {
                                default: _withCtx(() => [
                                  _hoisted_7
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, { type: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.state.multipleSelection.length) + " selecteds ", 1),
                              _createVNode(_component_el_divider, { direction: "vertical" }),
                              _hoisted_6,
                              _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_arrow_down)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_el_table, {
                ref: "multipleTable",
                class: "mt-3",
                onSelectionChange: _ctx.handleSelectionChange,
                data: _ctx.filterTableData,
                stripe: "",
                lazy: "",
                "max-height": "800px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    type: "selection",
                    width: "55"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "",
                    width: "120"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_image, {
                        class: "image-100",
                        src: _ctx.imageUrl(scope.row.mockupGallery[0], true),
                        "preview-src-list": [_ctx.imageUrl(scope.row.mockupGallery[0]), true],
                        "initial-index": 1
                      }, {
                        error: _withCtx(() => [
                          _createVNode(_component_slot_error)
                        ]),
                        _: 2
                      }, 1032, ["src", "preview-src-list"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    property: "name",
                    label: "Catalog"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_router_link, {
                          to: {
                  name: 'ag.base-cost.catalog-update',
                  params: { id: scope.row._id },
                }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_link, {
                              type: "primary",
                              href: _ctx.href
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.row.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["href"])
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    property: "name",
                    label: "Product Code"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", null, _toDisplayString(scope.row.productCode), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    property: "action",
                    label: "Action",
                    width: "200"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_button, {
                        onClick: ($event: any) => (
                _ctx.router.push({
                  name: 'ag.base-cost.catalog-update',
                  params: { id: scope.row._id },
                })
                ),
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Edit)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_el_popconfirm, {
                        "confirm-button-text": "Yes",
                        "cancel-button-text": "No",
                        icon: _ctx.InfoFilled,
                        "icon-color": "red",
                        title: "Are you sure to delete this?",
                        onConfirm: ($event: any) => (_ctx.onDeleteCatalog(scope.row))
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_button, { size: "small" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Delete)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["icon", "onConfirm"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onSelectionChange", "data"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.state.showModal,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.showModal) = $event)),
        title: "Product Catalog List",
        top: "7vh"
      }, _createSlots({
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.state.baseCost,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.baseCost) = $event)),
                    onChange: _ctx.onChangeBaseCost,
                    placeholder: "Select base cost"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.options, (group) => {
                        return (_openBlock(), _createBlock(_component_el_option_group, {
                          key: group.label,
                          label: group.label
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_8, _toDisplayString(item.label), 1),
                                  (item.default)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Default "))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.state.searchCatalog,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.searchCatalog) = $event)),
                      placeholder: "Search",
                      onChange: _ctx.onSearchCatalogs,
                      class: "mr-3"
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _createVNode(_component_el_table, {
                    ref: "multipleTable",
                    data: _ctx.availableCatalogs,
                    onSelectionChange: _ctx.onSelectionCatalogs,
                    height: "500"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        type: "selection",
                        width: "55"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "",
                        width: "120"
                      }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_el_image, {
                            class: "image-100",
                            src: _ctx.imageUrl(scope.row.mockupGallery[0], true),
                            "preview-src-list": [
                  _ctx.imageUrl(scope.row.mockupGallery[0]),
                  true,
                ],
                            "initial-index": 1
                          }, {
                            error: _withCtx(() => [
                              _createVNode(_component_slot_error)
                            ]),
                            _: 2
                          }, 1032, ["src", "preview-src-list"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        property: "name",
                        label: "Catalog"
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row.name), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Action",
                        width: "100"
                      }, {
                        default: _withCtx((scope) => [
                          (!_ctx.state.baseCostCatalogs.find(
                  s => s.productCode === scope.row.productCode
                )
                  )
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                onClick: ($event: any) => (_ctx.onAddCatalog(scope.row))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_11
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data", "onSelectionChange"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 2
      }, [
        (_ctx.state.selectionCatalogs && _ctx.state.selectionCatalogs.length > 0)
          ? {
              name: "footer",
              fn: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_el_button, {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.showModal = false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13,
                      _hoisted_14
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.onAddSelectionCatalogs
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            }
          : undefined
      ]), 1032, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.state.showModalAddSet,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.showModalAddSet) = $event)),
        title: "Update cost select catalog"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.state.radio1,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.radio1) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_button, { label: "Add" }),
                      _createVNode(_component_el_radio_button, { label: "Set" })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 6,
                offset: 1
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.state.action,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.action) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
              { value: true, title: '$' },
              { value: false, title: '%' },
            ], (item) => {
                        return _createVNode(_component_el_option, {
                          key: item.value,
                          label: item.title,
                          value: item.value,
                          size: 25
                        }, null, 8, ["label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 3,
                class: "text-right"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, null, {
                    default: _withCtx(() => [
                      _hoisted_16,
                      _hoisted_17
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}